import { Component, OnInit, OnChanges, ViewChild, Inject, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectedServiceDialogComponent } from '../../shared/dialog/selectedServiceDialog.component';
import { LoginService } from '../../shared/services/login.service';
import { BackgroundDashboardService } from '../../shared/services/backgroundDashboard.service';
import { BackgroundCheckService } from '../../get-my-background-check/background-shared/services/backgroundCheck.service';
import { CountryCheck } from '../../shared/models/countryCheck.model';
import { Router } from '@angular/router';
import { UserSelectedServicesModel } from '../../get-my-background-check/background-shared/model/UserSelectedServices.model';

@Component({
    selector: 'app-add-address',
    templateUrl: './addAddress.component.html',
})

export class AddAddressComponent implements OnInit {
    public GetState = [];
    public CountryCheck: CountryCheck = new CountryCheck();
    public Juridiction: any = [];


    constructor(public dialogRef: MatDialogRef<AddAddressComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public vcRef: ViewContainerRef, private _BackgroundCheckService: BackgroundCheckService,
        private _BackgroundDashboardService: BackgroundDashboardService, private _Router: Router) {
        // this.CountryCheck.State = localStorage.getItem('State');
        // this.CountryCheck.Zip = localStorage.getItem('Zip');
        // this.CountryCheck.City = localStorage.getItem('City');
        dialogRef.disableClose = true;
        this.Juridiction = this.data.newObj;
        //   this.GetJuridiction();
    }

    ngOnInit() {

        this.AddState();
    }

    AddState() {
        this._BackgroundCheckService.GetState().subscribe(res => this.GetStateSucess(res), res => this.GetStateError(res));
    }

    GetStateSucess(res) {
        this.GetState = res.json();
    }

    GetStateError(res) { }

    GetJurisdictionError(res) { }

    SubmitDetailsInSubjectTable() {
        this._BackgroundCheckService.InsertIntoUserJuridictions(localStorage.getItem('Email'), this.CountryCheck.Jurisdiction.toString(), true, this.CountryCheck.City, this.CountryCheck.State, this.CountryCheck.Zip).
            subscribe(res => this.InsertIntoUserJuridictionsSucess(res), res => this.InsertIntoUserJuridictionsError(res));

    }

    InsertIntoUserJuridictionsSucess(res) {
        this.onNoClick();
    }

    InsertIntoUserJuridictionsError(res) { }


    onNoClick(): void {
        this.dialogRef.close();
    }


}
